// extracted by mini-css-extract-plugin
export default {"congratsHeading":"CongratsModal_congratsHeading__wyCT2","congratsText":"CongratsModal_congratsText__eh1vH","dashboardButton":"CongratsModal_dashboardButton__8HzTD"};